import { useIsVirtualMarketer } from 'hooks/useIsVirtualMarketer'
import { BestPerformingPlatformPosts } from '../BestPerformingPlatformPosts/BestPerformingPlatformPosts'
import { Summary } from '../Summary/Summary'
import { Sections } from '../components/Sections/Sections'
import { GrowthAndDiscovery } from './GrowthAndDiscovery'
import { ProfileInteractions } from './ProfileInteractions'

export const Overview = () => {
  const isVirtualMarketer = useIsVirtualMarketer()

  return (
    <Sections>
      <Summary />
      {!isVirtualMarketer && <BestPerformingPlatformPosts />}
      <GrowthAndDiscovery />
      <ProfileInteractions />
    </Sections>
  )
}
